import { render, staticRenderFns } from "./OrcamentoItensTabela.vue?vue&type=template&id=ae7ed1f0&scoped=true"
import script from "./OrcamentoItensTabela.vue?vue&type=script&lang=js"
export * from "./OrcamentoItensTabela.vue?vue&type=script&lang=js"
import style0 from "./OrcamentoItensTabela.vue?vue&type=style&index=0&id=ae7ed1f0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ae7ed1f0",
  null
  
)

export default component.exports